$(document).ready(function() {

    if ($('.image-counter').length) {
        $('.image-counter .count-it').each(function () {
            let $this = $(this);
            
            let $countElement = $this;
            let originalNumber = parseInt($countElement.text().match(/\d+/)[0]);
        
            function random(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            let digitCount = originalNumber.toString().length;
            let random1 = '0'.repeat(digitCount);
            let random2 = random(digitCount);
            let random3 = random(digitCount);
            let random4 = random(digitCount);
            let random5 = random(digitCount);
    
            $countElement.html(`
                <span>${random1}</span>
                <span>${random2}</span>
                <span>${random3}</span>
                <span>${random4}</span>
                <span>${random5}</span>
                <span>${originalNumber}</span>
            `);
        });
    }

    if ($('.auto-slide-images').length) {
        $('.auto-slide-images .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: false,
                autoHeight: true,
                smartSpeed: 800,
                margin: 0,
                mouseDrag: false,
                touchDrag: false,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut'
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.logo-slider').length) {
        $('.logo-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 4,
                nav: false,
                dots: true,
                loop: true,
                autoplay:true,
                autoplayTimeout: 3000,
                autoHeight: true,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 50
                    },
                    768: {
                        items: 2,
                        margin: 20,
                        stagePadding: 50
                    },
                    1250: {
                        items: 4,
                        margin: 30,
                        stagePadding: 0
                    }
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.toggle-view-text').length) {
        let sections = $('.shopify-section:has(.toggle-view-text)');

        if (sections.length > 1) {
            sections.each(function() {
                let $current = $(this);
                let $prev = $current.prev('.shopify-section:has(.toggle-view-text)');

                if ($prev.length) {
                    $current.find('.container').css('padding-top', 0);
                }
            });

        }
    }
    
    image_counter();
    image_banner_text();
    video_banner();
    stack_only_effect();
    middle_banner();
    auto_slide_images();

});

$(window).on('scroll', function() {
    image_counter();
    image_banner_text();
    video_banner();
    stack_only_effect();
    middle_banner();
    auto_slide_images();
});

$(window).on('resize', function() {
    stack_only_effect();
});

function image_counter() {
    if ($('.image-counter').length) {
        $('.image-counter').each(function() {
            let el = $(this);

            let show = el.find('.show-up');

            if (visiblePercent(el) > 10) {
                show.addClass('show');
            }

            if (wSize >= 1250) {
                if (visiblePercent(el) > 50) {
                    el.find('.image-wrapper').addClass('active');
                    setTimeout(() => {
                        el.find('.count-it span').addClass('active');
                    }, 1000);
                }
            }
            else {
                if (visiblePercent(el) > 80) {
                    el.find('.count-it span').addClass('active');
                }
            }
            
        });    
    }
}

function image_banner_text() {
    if ($('.image-banner-text').length) {
        $('.image-banner-text').each(function() {
            let el = $(this);

            let show = el.find('.show-up');
        
            if (visiblePercent(el) > 50) {
                show.addClass('show');
            }
            else {
                show.removeClass('show');
            }
        });    
    }
}

function video_banner() {
    if ($('.video-banner').length) {
        $('.video-banner').each(function() {
            let el = $(this);

            let show = el.find('.show-up');
        
            if (visiblePercent(el) > 50) {
                show.addClass('show');
            }
            else {
                show.removeClass('show');
            }
        });    
    }
}

function stack_only_effect() {
    if ($('.stack-only.stack-effect').length) {
        $('.stack-only.stack-effect').each(function () {
            let el = $(this);
            let size = $(this).data('items') / 2;
            let scrolled = (sectionPercent(el) * size) + 25;
            let offset = 40;
            let mt = 100;
            let items = $(this).data('items');

            if (wSize >= 1250) {
                if (el.find('.container').attr('style')) {
                    if (items < 5) 
                        el.find('.container').css('height', '100vh');
                    else
                        el.find('.container').css('height', '110vh');
                }
            } else {
                let viewportHeight = $(window).height();
                let lastStackHeight = el.find('.stack').last().outerHeight(true);
                let lastStackVh = (lastStackHeight / viewportHeight) * 100;
                el.find('.container').css('height', `${lastStackVh + 20}vh`);
            }

            if (wSize >= 1920) {
                mt = 100;
                offset = 40;
            } else if (wSize >= 1440) {
                mt = 80;
                offset = 30;
            } else if (wSize >= 1250) {
                mt = 60;
                offset = 20;
            } else if (wSize >= 0) {
                mt = 40;
                offset = 15;
            }

            el.find('.stack:not(.first)').each(function (index) {
                $(this).css('margin-top', `${mt * (index + 1)}px`);
            });

            let maxHeight = 0;
            el.find('.stack').each(function () {
                let stackHeight = $(this).height();
                if (stackHeight > maxHeight) {
                    maxHeight = stackHeight;
                }
            });
            el.find('.stack').css('height', maxHeight + 'px');

            let totalHeight = maxHeight + (mt*items);
            el.find('.stacks').css('height', `${totalHeight}px`);

            if (wSize >= 1250) {
                if (scrolled >= 120 && scrolled < 145) {
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset * 2}px))`);
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(300% - ${offset * 3}px))`);
                } else if (scrolled >= 145 && scrolled < 170) {
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(200% - ${offset * 2}px))`);
                } else if (scrolled >= 170 && scrolled < 195) {
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="4"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                } else if (scrolled >= 195) {
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="4"]').css('transform', 'translateY(0)');
                    el.find('.stack[data-stack="5"]').css('transform', 'translateY(0)');
                } else {
                    el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px))`);
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset * 2}px))`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset * 3}px))`);
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(400% - ${offset * 4}px))`);
                }
            } else {
                if (scrolled >= 120 && scrolled < 145) {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.9)');
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(200% - ${offset * 2}px)) scale(1)`);
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(300% - ${offset * 3}px)) scale(1)`);
                } else if (scrolled >= 145 && scrolled < 170) {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.8)');
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.9)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(200% - ${offset * 2}px)) scale(1)`);
                } else if (scrolled >= 170 && scrolled < 195) {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.7)');
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.8)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(.9)');
                    el.find('.stack[data-stack="4"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                } else if (scrolled >= 195) {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(.6)');
                    el.find('.stack[data-stack="2"]').css('transform', 'translateY(0) scale(.7)');
                    el.find('.stack[data-stack="3"]').css('transform', 'translateY(0) scale(.8)');
                    el.find('.stack[data-stack="4"]').css('transform', 'translateY(0) scale(.9)');
                    el.find('.stack[data-stack="5"]').css('transform', 'translateY(0) scale(1)');
                } else {
                    el.find('.stack[data-stack="1"]').css('transform', 'translateY(0) scale(1)');
                    el.find('.stack[data-stack="2"]').css('transform', `translateY(calc(100% - ${offset}px)) scale(1)`);
                    el.find('.stack[data-stack="3"]').css('transform', `translateY(calc(200% - ${offset * 2}px)) scale(1)`);
                    el.find('.stack[data-stack="4"]').css('transform', `translateY(calc(300% - ${offset * 3}px)) scale(1)`);
                    el.find('.stack[data-stack="5"]').css('transform', `translateY(calc(400% - ${offset * 4}px)) scale(1)`);
                }
            }
        });
    }
}


function middle_banner() {
    if ($('.middle-banner').length) {
        $('.middle-banner').each(function() {
            let el = $(this);

            let show = el.find('.show-up');
        
            if (visiblePercent(el) > 50) {
                show.addClass('show');
            }
            else {
                show.removeClass('show');
            }

            if (el.hasClass('effect')) {
                if (visiblePercent(el) > 50) {
                    el.css('clip-path', 'polygon(0% 00%, 100% 00%, 100% 100%, 00% 100%)');
                }
                else {
                    el.css('clip-path', 'polygon(10% 20%, 90% 20%, 90% 80%, 10% 80%)');
                }
            }
        });    
    }
}

let autoSlideFired = false;
function auto_slide_images() {
    if ($('.auto-slide-images').length) {
        $('.auto-slide-images').each(function () {
            let el = $(this);

            let texts = $(this).find('.texts.desktop .text');
            let index = 0;

            function activateText(i) {
                texts.removeClass('active');
                texts.find('.innerline').css({
                    'width': '0%',
                    'transition': 'none'
                });

                const current = texts.eq(i);
                current.addClass('active');

                setTimeout(() => {
                    current.find('.innerline').css('transition', 'width 2s ease');
                    current.find('.innerline').css('width', '100%');
                }, 50);

                setTimeout(() => {
                    index = (i + 1) % texts.length;
                    activateText(index);
                    el.find('.owl-carousel').trigger('to.owl.carousel', index);
                }, 2000);
            }

            let texts_2 = $(this).find('.texts.mobile .text');
            let index_2 = 0;

            function activateText_2(i) {
                texts_2.removeClass('active');
                texts_2.find('.innerline').css({
                    'width': '0%',
                    'transition': 'none'
                });

                const current_2 = texts_2.eq(i);
                current_2.addClass('active');

                setTimeout(() => {
                    current_2.find('.innerline').css('transition', 'width 2s ease');
                    current_2.find('.innerline').css('width', '100%');
                }, 50);

                setTimeout(() => {
                    index_2 = (i + 1) % texts_2.length;
                    activateText_2(index_2);
                    el.find('.owl-carousel').trigger('to.owl.carousel', index_2);
                }, 2000);
            }

            if (visiblePercent(el) > 80 && !autoSlideFired) {
                activateText(index);
                activateText_2(index_2);
                autoSlideFired = true;
            }
        });
    }
}

$('.toggle-view-text .toggle').on('click', function() {
    $(this).toggleClass('active');
    $(this).parents('.toggle-view-text').find('.img').toggleClass('hide');
    $(this).parents('.toggle-view-text').find('.text-container').toggleClass('active');
});